import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-781602e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-2xl mb-3" }, "Stores", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "text-xs" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Active ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" InActive ")
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = { key: 5 }
const _hoisted_14 = { key: 6 }
const _hoisted_15 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_filter_table = _resolveComponent("filter-table")!
  const _component_SelectSellerTeam = _resolveComponent("SelectSellerTeam")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Refresh = _resolveComponent("Refresh")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_CustomerDetailDialog = _resolveComponent("CustomerDetailDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _component_Update = _resolveComponent("Update")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_section_layout_content, _normalizeProps(_guardReactiveProps(_ctx.content)), {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 24,
              class: "mt-3 flex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_filter_table, {
                  class: "mx-1",
                  onOnFilterCallback: _ctx.onFilterCallback,
                  placeholder: "Store name, App store Url",
                  title: "Store name, App store Url"
                }, null, 8, ["onOnFilterCallback"]),
                _createVNode(_component_SelectSellerTeam, {
                  modelValue: _ctx.params.sellerTeam,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.sellerTeam) = $event)),
                  class: "mx-1"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  class: "mx-1",
                  modelValue: _ctx.params.activated,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.activated) = $event)),
                  placeholder: "Status",
                  filterable: "",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { value: true, title: 'Active' },
              { value: false, title: 'Inactive' },
            ], (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.title,
                        value: item.value,
                        size: 25
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  class: "mx-1",
                  modelValue: _ctx.params.saleType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.saleType) = $event)),
                  placeholder: "Sale type",
                  filterable: "",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { value: 'pod', title: 'pod' },
              { value: 'fake', title: 'fk' },
              { value: 'drop', title: 'drop' },
            ], (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.title,
                        value: item.value,
                        size: 25
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_el_table, {
                  data: _ctx.documents,
                  stripe: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
                      return (_openBlock(), _createBlock(_component_el_table_column, {
                        key: index,
                        label: column.title,
                        props: column.dataIndex,
                        "min-width": column.minWidth,
                        align: column.align
                      }, {
                        default: _withCtx((scope) => [
                          (column.dataIndex == 'createdAt')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.formatTime(scope.row[column.dataIndex])), 1))
                            : (column.dataIndex == 'sellerTeam')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                  _createElementVNode("p", _hoisted_4, _toDisplayString(scope.row[column.dataIndex]?.name
                        ? scope.row[column.dataIndex]?.name
                        : scope.row[column.dataIndex]?.code), 1),
                                  _createElementVNode("p", _hoisted_5, _toDisplayString(scope.row[column.dataIndex].manager.email), 1)
                                ]))
                              : (column.dataIndex == 'activated')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                    (scope.row[column.dataIndex] === true)
                                      ? (_openBlock(), _createBlock(_component_el_tag, {
                                          key: 0,
                                          type: "success",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_7
                                          ]),
                                          _: 1
                                        }))
                                      : (scope.row[column.dataIndex] === false)
                                        ? (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 1,
                                            type: "danger",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_8
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                  ]))
                                : (column.dataIndex == 'saleType')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                      (scope.row[column.dataIndex] === 'pod')
                                        ? (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 0,
                                            type: "success",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(scope.row[column.dataIndex]), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (scope.row[column.dataIndex] === 'drop')
                                          ? (_openBlock(), _createBlock(_component_el_tag, {
                                              key: 1,
                                              type: "primary",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(scope.row[column.dataIndex]), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : (_openBlock(), _createBlock(_component_el_tag, {
                                              key: 2,
                                              type: "info",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(scope.row[column.dataIndex]), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                    ]))
                                  : (column.dataIndex == 'appShopUrl')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                        (scope.row['domain'])
                                          ? (_openBlock(), _createElementBlock("p", {
                                              key: 0,
                                              class: "font-bold",
                                              title: scope.row['domain']
                                            }, _toDisplayString(scope.row['domain']), 9, _hoisted_11))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("p", {
                                          class: "text-xs",
                                          title: scope.row['appShopUrl']
                                        }, _toDisplayString(scope.row['appShopUrl']), 9, _hoisted_12)
                                      ]))
                                    : (column.dataIndex == 'action')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                          _createVNode(_component_el_link, {
                                            onClick: ($event: any) => (_ctx.onEditStore(scope.row.id.toString())),
                                            title: "Config store",
                                            underline: false,
                                            type: "primary"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, { style: {"font-size":"1.25rem"} }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Edit)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          (scope.row['storeType'] === 'lattehub')
                                            ? (_openBlock(), _createBlock(_component_el_button, {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.fetchDomain(scope.row.id.toString())),
                                                text: "",
                                                type: "primary",
                                                title: "Fetch domain",
                                                loading: _ctx.isFetching
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_icon, { style: {"font-size":"1.25rem"} }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Refresh)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick", "loading"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (column.dataIndex == 'subscriptionId')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(scope.row[column.dataIndex]?.code), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(scope.row[column.dataIndex]), 1))
                        ]),
                        _: 2
                      }, 1032, ["label", "props", "min-width", "align"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["data"]), [
                  [_directive_loading, _ctx.isLoading]
                ]),
                _createVNode(_component_pagination, {
                  total: _ctx.total,
                  pagination: _ctx.params.page,
                  "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.page) = $event)),
                  limit: _ctx.params.limit,
                  "onUpdate:limit": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.limit) = $event))
                }, null, 8, ["total", "pagination", "limit"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_CustomerDetailDialog, { ref: "customerDetailDialog" }, null, 512)
      ]),
      _: 1
    }, 16),
    _createVNode(_component_Update, {
      ref: "updateStoreDialog",
      onOnAfterUpdate: _ctx.onAfterUpdate
    }, null, 8, ["onOnAfterUpdate"])
  ], 64))
}